import { EnrollmentLocationId, LocationError } from '@pages/enroll/locations'
import {
  EnrollmentLocation,
  LocationCoordinates,
} from '@utils/getNearbyEnrollmentLocations'
import React, { ChangeEvent } from 'react'
import V1LocationsSearch from './v1'
import V2LocationsSearch from './v2'

export interface LocationsSearchProps {
  displayLocationSearchRevisedLayout: boolean
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  handleSearch: (searchCriteria: string) => Promise<void>
  updateSearchBar: (e: ChangeEvent<HTMLInputElement>) => void
  searchInput: string
  geoLocateSuccessHandler: (position: GeolocationPosition) => void
  mapSearchError: boolean
  locationsWithinRange: EnrollmentLocation[]
  errors: LocationError
  isLoaded: boolean
  searchLocation: LocationCoordinates
  determineMapZoomLevel: (locationsWithinRange: EnrollmentLocation[]) => number
  isSearchComplete: boolean
  isLoading: boolean
  defaultZip?: string
  enrollmentLocationId?: string
  onSubmit?: ({ enrollmentLocationId }: EnrollmentLocationId) => Promise<void>
  handleSelect?: (location: string) => void
  selectionKey?: 'locationCode' | 'serviceTerritoryId'
  shouldAutoSelectLocation?: boolean
}

export default function LocationsSearch({
  displayLocationSearchRevisedLayout,
  handleKeyDown,
  handleSearch,
  updateSearchBar,
  searchInput,
  geoLocateSuccessHandler,
  mapSearchError,
  locationsWithinRange,
  errors,
  isLoaded,
  searchLocation,
  determineMapZoomLevel,
  isSearchComplete,
  enrollmentLocationId,
  handleSelect = () => void 0,
  defaultZip,
  selectionKey,
  shouldAutoSelectLocation,
}: LocationsSearchProps) {
  return displayLocationSearchRevisedLayout ? (
    <V2LocationsSearch
      handleKeyDown={handleKeyDown}
      handleSearch={handleSearch}
      updateSearchBar={updateSearchBar}
      searchInput={searchInput}
      geoLocateSuccessHandler={geoLocateSuccessHandler}
      mapSearchError={mapSearchError}
      locationsWithinRange={locationsWithinRange}
      errors={errors}
      isLoaded={isLoaded}
      searchLocation={searchLocation}
      determineMapZoomLevel={determineMapZoomLevel}
      isSearchComplete={isSearchComplete}
      enrollmentLocationId={enrollmentLocationId}
      defaultZip={defaultZip}
      handleSelect={handleSelect}
      selectionKey={selectionKey}
      shouldAutoSelectLocation={shouldAutoSelectLocation}
    />
  ) : (
    <V1LocationsSearch
      handleKeyDown={handleKeyDown}
      handleSearch={handleSearch}
      updateSearchBar={updateSearchBar}
      searchInput={searchInput}
      geoLocateSuccessHandler={geoLocateSuccessHandler}
      mapSearchError={mapSearchError}
      locationsWithinRange={locationsWithinRange}
      errors={errors}
      isLoaded={isLoaded}
      searchLocation={searchLocation}
      determineMapZoomLevel={determineMapZoomLevel}
      isSearchComplete={isSearchComplete}
      handleSelect={handleSelect}
      selectionKey={selectionKey}
    />
  )
}
